/* eslint-disable no-console */
/**
 * Logs the state (values only, no actions) of all common Zustand stores to the console.
 * Call when user is logged in (e.g. after initialization is ready) for debugging.
 */

import { useOnboardingStore } from '@common/apps'
import { useGatewaysStore } from '@common/modules/gateways/stores'
import { useProjectsStore } from '@common/modules/projects/stores'
import { useAccountStore } from '@common/modules/settings/account/stores'
import { useOrganizationsStore } from '@common/modules/settings/organizations/stores'
import { useWorkspaceStore } from '@common/modules/settings/workspace/stores'
import { useUserStore } from '@common/modules/user/stores'
import { useWorkspacesStore } from '@common/modules/workspaces/stores'

import { useSessionStore } from '../stores/session.store'

const LOG_LABEL = '[Zustand] Stores (logged in)'

function getStoreValuesOnly<T extends object>(state: T): Record<string, unknown> {
  const result: Record<string, unknown> = {}
  for (const [key, value] of Object.entries(state)) {
    if (typeof value === 'function') continue
    result[key] = value
  }
  return result
}

export function logZustandStores(): void {
  if (typeof window === 'undefined') return

  try {
    const session = getStoreValuesOnly(useSessionStore.getState())
    const user = getStoreValuesOnly(useUserStore.getState())
    const workspaces = getStoreValuesOnly(useWorkspacesStore.getState())
    const projects = getStoreValuesOnly(useProjectsStore.getState())
    const onboarding = getStoreValuesOnly(useOnboardingStore.getState())
    const gateways = getStoreValuesOnly(useGatewaysStore.getState())
    const accountSettings = getStoreValuesOnly(useAccountStore.getState())
    const organizationsSettings = getStoreValuesOnly(useOrganizationsStore.getState())
    const workspaceSettings = getStoreValuesOnly(useWorkspaceStore.getState())

    console.group(LOG_LABEL)
    console.log('SessionStore', session)
    console.log('UserStore', user)
    console.log('WorkspacesStore', workspaces)
    console.log('ProjectsStore', projects)
    console.log('OnboardingStore', onboarding)
    console.log('GatewaysStore', gateways)
    console.log('AccountSettingsStore', accountSettings)
    console.log('OrganizationsSettingsStore', organizationsSettings)
    console.log('WorkspaceSettingsStore', workspaceSettings)
    console.groupEnd()
  } catch (e) {
    console.warn(LOG_LABEL, e)
  }
}
